export const visible = (self: Element, options?: IntersectionObserverInit) =>
  new Promise<void>((resolve) => {
    new IntersectionObserver((entries) => {
      if (entries.some(({ isIntersecting }) => isIntersecting)) {
        resolve();
      }
    }, options).observe(self);
  });
